<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">ACKNOWLEDGMENTS</h2>
<p class="noindent">Thank you, Bonnie, for standing by my side since May 22, 1993. You are God’s biggest blessing in my life. I am forever grateful you said “yes.” You model well the lessons included in this book. You are no stranger to pain; yet, because of your great love for Jesus, you have no problem <span class="aitalic">Finding Hope in Hardship</span>.</p>
<p class="indent">Ryleigh Watson, thank you for serving as my editor. You have a sharp eye, a keen sense for excellence, and a big heart.</p>
<p class="indent">David Hancock, you and the team at Morgan James Publishing are a true blessing. Thank you for believing in me as an author and for being the best publisher and the best publishing company, I know.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?5b26692e